export default function About() {
  return (
    <section id="about" className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-8 text-center">
        <p className="text-xs uppercase tracking-widest text-gray-500 mb-16">WHO WE ARE</p>
        <p className="text-3xl leading-relaxed text-gray-800 font-light" style={{ fontFamily: 'Georgia, serif' }}>
          OGIN d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices. 🛡️
        </p>
      </div>
    </section>
  );
}
